import { createTheme } from "@mui/material/styles";
import { secondaryColor as secondaryColorValue } from "../scss/colors.module.scss";

export const getColorByPropertyValue = (value) => {
  if (typeof document !== "undefined") {
    const computedValue = getComputedStyle(
      document.documentElement
    ).getPropertyValue(value);
    // Return the computed value if it exists and is not empty
    return computedValue.trim() || null;
  }
  return null;
};

// Helper function to resolve CSS variables
export const resolveColor = (color) => {
  if (color.startsWith("var(")) {
    // Extract the CSS variable name from var(--variableName)
    const variableName = color.match(/var\(([^)]+)\)/)?.[1];
    if (variableName) {
      return getColorByPropertyValue(variableName) || color;
    }
  }
  return color;
};

export const getThemeColor = () => {
  const primaryColor = getColorByPropertyValue("--primaryColor") || "#162029";
  const secondaryColor =
    getColorByPropertyValue("--secondaryColor") || "#04f73d";
  const textColor = getColorByPropertyValue("--testColor") || "#051315";
  return {
    primaryColor,
    secondaryColor,
    textColor,
  };
};

export const theme = createTheme({
  typography: {
    fontFamily: "ProximaNovaRegular",
  },
  palette: {
    primary: {
      main: "#162029",
    },
    secondary: {
      main: "#04f73d",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1025,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: ({ theme: muiTheme }) => ({
          backgroundColor: "white",
          color: "rgba(0, 0, 0, 0.87)",
          fontSize: "16px",
          boxShadow: muiTheme.shadows[1],
          border: `1px solid ${secondaryColorValue}`,
          "& .MuiTooltip-arrow": {
            color: "white",
            "&::before": {
              border: `1px solid ${secondaryColorValue}`,
            },
          },
        }),
      },
    },
  },
});
